import { merchCapConfig } from 'app/shared/configs';
import { RootState } from 'app/store/rootReducer';
import { selectIsMerchCapSelected } from 'app/store/data/quotation';
import { selectIsMerchCapUpsellAbTestActive } from './selectIsMerchCapUpsellAbTestActive';

export const selectMerchCapPriceAddition = (state: RootState) =>
  selectIsMerchCapUpsellAbTestActive(state) && selectIsMerchCapSelected(state)
    ? merchCapConfig.price + merchCapConfig.deliveryPrice
    : 0;
